/**
 * @module actions/invoicing
 */
import axios from 'axios'
import { API_URL } from '../constants'

/**
 * @description Invoice an order
 * @return {Promise} Axios promise
 */
export function invoiceOrder (data) {
  let url = API_URL + '/Invoice/'
  return dispatch => {
    return axios.post(url, data)
  }
}
/**
 * @description Get last invoice history
 * @return {Promise} Axios promise
 */
export function invoiceHistory (orderid) {
  let url = API_URL + '/LastInvoiceHistory/' + orderid
  return dispatch => {
    return axios.get(url)
  }
}
/**
 * @description Approve order for invoice
 * @return {Promise} Axios promise
 */
export function approveOrderInvoice (orderId, undo) {
  let url = API_URL + '/InvoiceReady'
  let data = {
    OrderId: orderId,
    Undo: undo
  }
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Mark order as invoiced
 * @return {Promise} Axios promise
 */
export function markAsInvoiced (orderId) {
  let url = API_URL + '/MarkInvoiced'
  let data = {
    OrderId: orderId
  }
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get order invoice status
 * @return {Promise} Axios promise
 */
export function getInvoiceStatus (orderId) {
  let url = API_URL + '/GetInvoiceStatus/' + orderId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description MassInvoice orders
 * @return {Promise} Axios promise
 */
export function massInvoiceOrders (data) {
  let url = API_URL + '/MassInvoice'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Mass mark as invoiced
 * @return {Promise} Axios promise
 */
export function massMarkInvoiced (ids) {
  let url = API_URL + '/MassMarkInvoiced'
  return dispatch => {
    return axios.post(url, ids)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/invoicing.js